import React, { Component } from 'react';
import countryNamesByISO from '../../../utils/regionCodeMappings';
import allCountriesData from '../../../utils/country-code-mapping';
import {
  dialCode,
} from '../../../partnerStyles';
import DropdownMenuMobile from '../../../common/DropdownMenMobileu';
import DropdownMenuLocation from '../../../common/DropDownLocation';
import { NavLink } from 'react-router-dom';
import * as GlobalActions from '../../../reducers/actions';
import { connect } from 'react-redux';
import LandingStyles from '../LandingStyles';
import LandingImages from '../LandingImages';
import { S3HOST } from '../../../ApiConstants';
import { bindActionCreators } from 'redux';
import SelectionCard from '../LandingSubComponents/SelectionCard';
import view, { borders, propertyType, validation } from '../../../Enums';
import { validateUserPhoneNumber } from '../../../utils/tempInputUtils';
import { guc } from '../../../services/Localisation';
import { Event } from '../Tracking/Track';
import Revenue from '../LandingSubComponents/Revenue';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { earningPotentialEnabled } from '../../../config/countryConfig';
import { isEmptyObject, isEmptyString, path } from '../../../utils';
import { EVENT_CATEGORIES, EVENT_ACTIONS, logEvent } from '../../../services/Analytics';

class BecomeAnOyoForm3 extends Component {
  constructor(props) {
    super(props);
    this.onLocationTextUpdate = this.onLocationTextUpdate.bind(this);
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  state = {
    showDropdown: false,
    dropDownOptions: [],
    selectedLocation: null,
    showDropdownMobile: false,
    flagPos: 1360,
    resultant_ph_no: null,
    name_border: borders.NORMAL_BORDER,
    ph_no_border: borders.NORMAL_BORDER,
    location_border: borders.NORMAL_BORDER,
    name_border_validated: true,
    ph_no_border_validated: true,
    location_border_validated: true,
    debounceTimer: null,
    location: '',
    location_error:'',
    email_border: borders.NORMAL_BORDER,
    email_border_validated: true,
    propertyBorder: borders.NORMAL_BORDER,
    addressBorder: borders.NORMAL_BORDER,
    propertyBorder_validated: true,
    addressBorder_validated: true,
  };

  getContent = key => {
    if (
      this.props &&
      this.props.globalData &&
      this.props.globalData.landing_translations &&
      this.props.viewMode
    ) {
      return this.props.globalData.landing_translations[key];
    }
    return null;
  };

  getUniversalContent = key => {
    if (
      this.props &&
      this.props.globalData &&
      this.props.globalData.universal_translations &&
      this.props.viewMode
    ) {
      if (key in this.props.globalData.universal_translations)
        return this.props.globalData.universal_translations[key];
    }
    return null;
  };

  getStyle = style_id => {
    if (style_id in LandingStyles)
      return LandingStyles[style_id][this.props.viewMode];
    console.log(style_id + ' style not initialized.');
    return {};
  };

  getImage = image_id => {
    if (image_id in LandingImages) {
      return (
        S3HOST +
        '/' +
        this.props.globalData.universal_translations[
          LandingImages[image_id][this.props.viewMode]
        ]
      );
    }
    console.log(image_id + ' image not initialized.');
    return null;
  };

  onClickJoinUs = e => {
    this.state.joinUsExecuted = true;
    let isValidated = this.validateFields();
    let label_s = 'Failure';

    if (isValidated) {
      label_s = 'Success';
    }
    if (this.props.globalData.type_of_property == propertyType.HOTEL) {
      Event('Partner Page landing form', 'Property type selected', 'Hotel', '');
    }
    if (this.props.globalData.type_of_property == propertyType.HOME) {
      Event('Partner Page landing form', 'Property type selected', 'Home', '');
    }

    Event(
      'Partner Page landing form',
      'Request a call on landing form clicked',
      label_s,
      ''
    );

    if (isValidated) {

      let typeOfProperty = 'Hotel';
      if (this.props.globalData.type_of_property === propertyType.HOME) {
        typeOfProperty = 'Home';
      }

      this.props.globalActions.switchSellerBool(false);
      if (
        this.props.globalData.formData.mobile_number ||
        // || this.props.globalData.formData.full_name
        this.props.globalData.location
      ) {
        let toSend = {
          source: 'OAM',
          sub_source_code: this.props.utm_data,
          hotel_total_rooms: null,
          owner_name: this.props.globalData.formData.full_name,
          property_component_type: typeOfProperty,
          owner_primary_mobile_number: this.props.globalData.formData
            .mobile_number,
          metadata: {
            freetext: this.state.location,
            medium: 'OAM WEB',
            landingCountry:
              countryNamesByISO[this.props.globalData.locale] ||
              this.props.globalData.locale
          }
        };
        if (guc('emailBecomeAnOyoForm3Enabled', false)) toSend = {
          ...toSend,
          owner_email: this.props.globalData.formData.email_address,
          street_address: this.props.globalData.formData.hotel_address,
          name: this.props.globalData.formData.hotel_name
        };
        if (this.state.selectedLocation) {
          let selected = this.state.selectedLocation;
          if (selected.city) toSend['city'] = selected.city.name;
          if (selected.country) toSend['country'] = selected.country.name;
        }
        this.props.globalActions.putPropertyfetch(toSend);
      }
    } else {
      e.preventDefault();
    }
  };

  validateOneField = (field, value) => {
    switch (field) {
      case validation.LOCATION:
        if (isEmptyObject(this.state.selectedLocation)) {
          this.setState({ location_border_validated: false });
          return false;
        } else {
          this.setState({ location_border_validated: true });
          return true;
        }
      case validation.LOCATION_OBJECT:
        if (Object.keys(this.props.globalData.selected_location).length == 0) {
          this.setState({ location_border_validated: false });
          return false;
        } else {
          this.setState({ location_border_validated: true });
          return true;
        }

      case validation.REVENUE_POTENTIAL:
        if (
          !this.props.globalData.earning_potential_data.noDataForCity &&
          this.props.globalData.earning_potential_data.data.length == 0
        ) {
          this.setState({ location_border_validated: false });
          return false;
        } else {
          return true;
        }

      case validation.PHONE_NUMBER:
        if (
          !validateUserPhoneNumber(
            this.props.globalData.formData.mobile_number,
            this.props.globalData.locale
          )
        ) {
          this.setState({ ph_no_border_validated: false });
          return false;
        } else {
          this.setState({ ph_no_border_validated: true });
          return true;
        }

      case validation.FULL_NAME:
        if (!this.props.globalData.formData.full_name) {
          this.setState({ name_border_validated: false });
          return false;
        } else {
          this.setState({ name_border_validated: true });
          return true;
        }
      case validation.HOTEL_EMAIL:
        const emailToCheck = value || this.props.globalData.formData.email_address ;
        if (!emailToCheck || emailToCheck.indexOf('@') < 0 || emailToCheck.lastIndexOf('.') < emailToCheck.indexOf('@')) {
          this.setState({ email_border_validated: false });
          return false;
        }
        this.setState({ email_border_validated: true });
        return true;
      case validation.HOTEL_PROPERTY_NAME:
        const nameToCheck = value || this.props.globalData.formData.hotel_name ;
        if (nameToCheck.length == 0) {
          this.setState({ propertyBorder_validated: false });
          return false;
        }
        this.setState({ propertyBorder_validated: true });
        return true;
      case validation.HOTEL_PROPERTY_ADDRESS:
        const addressToCheck = value || this.props.globalData.formData.hotel_address ;
        if (addressToCheck.length == 0) {
          this.setState({ addressBorder_validated: false });
          return false;
        }
        this.setState({ addressBorder_validated: true });
        return true;
      default:
        return false;
    }
  };

  validateFields = () => {
    let validateFullName = this.validateOneField(validation.FULL_NAME);
    let validatePhoneNumber = this.validateOneField(validation.PHONE_NUMBER);
    let validateLocation = this.validateOneField(validation.LOCATION);
    const validatedFields = validateFullName && validatePhoneNumber && validateLocation;
    const validateEmail = this.validateOneField(validation.HOTEL_EMAIL);
    const validatePropertyName = this.validateOneField(validation.HOTEL_PROPERTY_NAME);
    const validatePropertyAddress = this.validateOneField(validation.HOTEL_PROPERTY_ADDRESS);
    return guc('emailBecomeAnOyoForm3Enabled' , false) ? validatedFields &&  validateEmail && validatePropertyName && validatePropertyAddress: validatedFields;
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      prevProps.globalData.locationData.isFetching &&
      !this.props.globalData.locationData.isFetching &&
      this.props.globalData.location
    ) {
      if (
        this.props.globalData.locationData.location.responseObject &&
        this.props.globalData.locationData.location.responseObject.length
      ) {
        this.setState({
          showDropdown: true,
          dropDownOptions: this.props.globalData.locationData.location
            .responseObject
        });
      } else {
        this.setState({
          showDropdown: true,
          dropDownOptions: [{
            type : 'error',
            displayName: 'Can\'t find relevant results, try retyping'
          }]
        });
      }
    }
  }

  componentDidMount() {
    window.onclick = e => {
      this.setState({ showDropdown: false });
      document.addEventListener('mousedown', this.handleClickOutside);
    };

    let mobile_number = this.props.globalData.formData.mobile_number;
    if (
      !validateUserPhoneNumber(
        this.props.globalData.formData.mobile_number,
        this.props.globalData.locale
      )
    ) {
      mobile_number = '';
      this.props.globalActions.dataUpdate('mobile_number', '');
    }

    console.log(this.props.globalData.locale.toUpperCase());
    this.flagAndDialCode(
      this.props.globalData.locale.toUpperCase(),
      mobile_number
    );
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ showDropdownMobile: false });
    }
  }

  onClickDropdown = locationObject => {
    this.setState({ location_border_validated: true });
    this.props.globalActions.updateLocation(locationObject.displayName);
    if (locationObject.city)
      this.props.globalActions.dataUpdate('city', locationObject.city.name);
    if (locationObject.country)
      this.props.globalActions.dataUpdate(
        'country',
        locationObject.country.name
      );
    this.props.globalActions.updateLocationObject(locationObject);
    // this.props.globalActions.dataUpdate('selected_location', locationObject);
    this.setState({
      showDropdown: false,
      dropDownOptions: [],
      selectedLocation: locationObject,
      location_error: ''
    });
  };

  onLocationTextUpdate = e => {
    Event('Partner Page landing form', 'Location entered', '', '');

    let query = e.target.value;
    this.setState({ location: query , selectedLocation : null , location_error : ''});
    this.props.globalActions.updateLocation(query);
    if (this.state.debounceTimer) clearTimeout(this.state.debounceTimer);
    if (query) {
      this.setState({
        debounceTimer: setTimeout(() => this.getLocationSuggestions(query), 200)
      });
    } else {
      this.setState({ showDropdown: false });
    }
  };

  getLocationSuggestions = query => {
    let region = this.props.globalData.locale.toUpperCase();
    if (region === 'DF') region = 'IN';
    let country_code = this.props.globalData.locale.toUpperCase();
    if (country_code === 'UK') country_code = 'GB';
    this.props.globalActions.fetchLocationSearch(query, country_code);
  };

  changeMobile = () => {
    let showDropdownMobile = this.state.showDropdownMobile;
    this.setState({ showDropdownMobile: !showDropdownMobile });
  };
  flag = country_iso_code => {
    let dialCode = allCountriesData[country_iso_code][0];
    let flagPos = (allCountriesData[country_iso_code][1] - 1) * 16;
    this.props.globalActions.dataUpdate('dial_code', dialCode);
    this.props.globalActions.dataUpdate('flagPos', flagPos);
    this.setState(
      { resultant_ph_no: dialCode + ' ', flagPos: flagPos },
      this.changeMobile()
    );
  };
  flagAndDialCode(country_iso_code, mobile_number) {
    let dialCode = allCountriesData[country_iso_code][0];
    let flagPos = (allCountriesData[country_iso_code][1] - 1) * 16;
    this.props.globalActions.dataUpdate('dial_code', dialCode);
    this.props.globalActions.dataUpdate('flagPos', flagPos);
    this.setState({ resultant_ph_no: dialCode + ' ' + mobile_number });
    this.setState({ flagPos: flagPos });
  }

  onChangeMobileInput = e => {
    Event('Partner Page landing form', 'Mobile number entered', '', '');

    let val = e.target.value;
    let normal_border = 'solid 1px rgba(0, 0, 0, 0.08)';
    let dial_code_length = this.props.globalData.formData.dial_code.length;
    if (val.length == 0) {
      this.setState({
        resultant_ph_no: this.props.globalData.formData.dial_code + ' '
      });
    }
    if (val.length == 1 && !isNaN(val)) {
      this.setState({
        resultant_ph_no: this.props.globalData.formData.dial_code + ' ' + val
      });
    }
    if (val.length < dial_code_length) return;
    let mobile_number = val.substring(dial_code_length + 1).trim();
    if (validateUserPhoneNumber(mobile_number, this.props.globalData.locale))
      this.setState({ ph_no_border_validated: true });
    // this.setState({ ph_no_border: normal_border });

    if (isNaN(mobile_number)) return;
    this.props.globalActions.dataUpdate('mobile_number', mobile_number);
    this.setState({
      resultant_ph_no:
        this.props.globalData.formData.dial_code + ' ' + mobile_number
    });
  };
  
  handleClickAway = () =>{
    let location_error = '';
    if(!this.state.selectedLocation && this.state.location)
      location_error = this.getUniversalContent('location_error') ;
    
    this.setState({ showDropdown  : false , location_error : location_error });
  }

  render() {
    let gc = this.getContent;
    let guc = this.getUniversalContent;
    let gi = this.getImage;
    let gs = this.getStyle;
    let flagImage, dial_Code;
    flagImage = {
      ...gs('flag_style'),
      backgroundPosition: '0 -' + this.state.flagPos + 'px'
    };
    dial_Code = dialCode;

    let formContainerStyle;
    let selectionCardHeight, selectionCardWidth, selectionCardPosition;

    selectionCardHeight = '56px';
    selectionCardWidth = '48%';
    if (this.props.viewMode == view.DESKTOP) {
      formContainerStyle = {
        ...gs('oyo_form_container'),
        top: this.props.borderTopBecomeOyoForm + 'px',
        height:
          this.props.becomeOyoFormHeight +
          this.props.becomeOyoFormExtraHeight +
          'px',
        right: this.props.rightMarginForForm + 'px'
      };
    } else {
      formContainerStyle = {
        ...gs('oyo_form_container'),
        height: 460 + this.props.becomeOyoFormExtraHeight + 'px'
      };
    }

    if (this.props.highLightForm) {
      formContainerStyle = {
        ...formContainerStyle,
        border: 'solid 3px rgba(240, 0, 0, 0.7)'
      };
    }
    const formHeight = parseInt(formContainerStyle['height']) - parseInt(selectionCardHeight) - parseInt(gs('join_us_btn').height) - 55 + 'px';
    
    return (
      <React.Fragment>
        {this.props.globalData.landing_translations && this.props.viewMode && (
          <div style={formContainerStyle} className={'animate'}>
            <div
              style={{
                ...gs('main_form_style'),
                height: formContainerStyle['height']
              }}
            >
              <div style={gs('become_oyo_style')}>
                {this.props.globalData.landing_translations.become_an_oyo}
              </div>
              <div style={guc('emailBecomeAnOyoForm3Enabled') ? { overflowY: 'auto', height: formHeight } : {}}>
              <div style={gs('form_small_text')}>{gc('name')}</div>
              <input
                type="text"
                placeholder={gc('name_placeholder')}
                autoComplete="new-password"
                onChange={e => {
                  if (e.target.value.length > 0) {
                    Event('Partner Page landing form', 'Name entered', '', '');
                    this.setState({ name_border_validated: true });
                  }

                  this.props.globalActions.dataUpdate(
                    'full_name',
                    e.target.value
                  );
                }}
                onBlur={() => {
                  this.setState({
                    name_border: 'solid 1px rgba(0, 0, 0, 0.08)'
                  });
                }}
                onFocus={() => {
                  this.setState({
                    name_border: 'solid 1px rgba(0, 0, 0, 0.5)'
                  });
                }}
                value={this.props.globalData.formData.full_name}
                className={'removeFocusOutline'}
                style={{
                  ...gs('input_form'),
                  border: this.state.name_border_validated
                    ? this.state.name_border
                    : borders.RED_BORDER
                }}
              />

              <div style={gs('form_small_text')}>{gc('mobile_number')}</div>

              <div
                style={gs('mobile_number_container')}
                ref={this.setWrapperRef}
              >
                <span
                  style={gs('cursor_pointer_style')}
                  className={'cursorPointer'}
                  onClick={this.changeMobile}
                >
                  <img style={gs('down_arrow_style')} src={gi('down_arrow')} />
                </span>

                <span
                  style={{
                    ...flagImage,
                    ...gs('flag_image_style')
                  }}
                  className={'cursorPointer'}
                  onClick={this.changeMobile}
                />
                <input
                  placeholder={gc('mobile_number_placeholder')}
                  autoComplete="new-password"
                  onChange={this.onChangeMobileInput}
                  value={this.state.resultant_ph_no}
                  className={'removeFocusOutline'}
                  style={{
                    ...gs('input_form'),
                    padding: '10px 0px 10px 61px',
                    width: this.props.viewMode == view.DESKTOP ? '82%' : '86%',
                    border: this.state.ph_no_border_validated
                      ? this.state.ph_no_border
                      : borders.RED_BORDER
                  }}
                  onFocus={() => {
                    this.setState({
                      ph_no_border: 'solid 1px rgba(0, 0, 0, 0.5)'
                    });
                  }}
                  onBlur={() => {
                    this.setState({
                      ph_no_border: 'solid 1px rgba(0, 0, 0, 0.08)'
                    });
                  }}
                />
                {this.state.showDropdownMobile && (
                  <DropdownMenuMobile
                    id={'locDrop'}
                    viewSize={'Desktop'}
                    k={this.flag}
                    topPos={'4px'}
                    divWidth={'100%'}
                    divTop={'48px'}
                  />
                )}
              </div>
              { guc('emailBecomeAnOyoForm3Enabled') &&
                <>
                <div style={gs('form_small_text')}>{guc('your_email') + '*'}</div>
              <input
                  type="text"
                  autoComplete="new-password"
                  onChange={e => {
                    this.validateOneField(validation.HOTEL_EMAIL, e.target.value);
                    this.props.globalActions.dataUpdate(
                        'email_address',
                        e.target.value
                    );
                    logEvent(EVENT_CATEGORIES.PARTNER_PAGE_LANDING_FORM, EVENT_ACTIONS.EMAIL_ENTERED,e.target.value)
                  }}
                  onBlur={() => {
                    this.setState({
                      email_border: 'solid 1px rgba(0, 0, 0, 0.08)'
                    });
                  }}
                  onFocus={() => {
                    this.setState({
                      email_border: 'solid 1px rgba(0, 0, 0, 0.5)'
                    });
                  }}
                  value={path(this.props.globalData, 'formData.email_address', '')}
                  className={'removeFocusOutline'}
                  style={{
                    ...gs('input_form'),
                    border: this.state.email_border_validated
                        ? this.state.email_border
                        : borders.RED_BORDER
                  }}
              />
                  <div style={gs('form_small_text')}>{guc('prop_name')}</div>
                  <input
                      type="text"
                      autoComplete="new-password"
                      onChange={e => {
                        this.validateOneField(validation.HOTEL_PROPERTY_NAME, e.target.value);
                        this.props.globalActions.dataUpdate(
                            'hotel_name',
                            e.target.value
                        );
                        logEvent(EVENT_CATEGORIES.PARTNER_PAGE_LANDING_FORM, EVENT_ACTIONS.PROPERTY_NAME_ENTERED,e.target.value)
                      }}
                      onBlur={() => {
                        this.setState({
                          propertyBorder: 'solid 1px rgba(0, 0, 0, 0.08)'
                        });
                      }}
                      onFocus={() => {
                        this.setState({
                          propertyBorder: 'solid 1px rgba(0, 0, 0, 0.5)'
                        });
                      }}
                      value={path(this.props.globalData, 'formData.hotel_name', '')}
                      className={'removeFocusOutline'}
                      style={{
                        ...gs('input_form'),
                        border: this.state.propertyBorder_validated
                            ? this.state.propertyBorder
                            : borders.RED_BORDER
                      }}
                  />
                  <div style={gs('form_small_text')}>{guc('prop_address') + '*'}</div>
                  <input
                      type="text"
                      autoComplete="new-password"
                      onChange={e => {
                        this.validateOneField(validation.HOTEL_PROPERTY_ADDRESS, e.target.value);
                        this.props.globalActions.dataUpdate(
                            'hotel_address',
                            e.target.value
                        );
                        logEvent(EVENT_CATEGORIES.PARTNER_PAGE_LANDING_FORM, EVENT_ACTIONS.EMAIL_ENTERED,e.target.value)
                      }}
                      onBlur={() => {
                        this.setState({
                          addressBorder: 'solid 1px rgba(0, 0, 0, 0.08)'
                        });
                      }}
                      onFocus={() => {
                        this.setState({
                          addressBorder: 'solid 1px rgba(0, 0, 0, 0.5)'
                        });
                      }}
                      value={path(this.props.globalData, 'formData.hotel_address', '')}
                      className={'removeFocusOutline'}
                      style={{
                        ...gs('input_form'),
                        border: this.state.addressBorder_validated
                            ? this.state.addressBorder
                            : borders.RED_BORDER
                      }}
                  />
                </>}
              <div style={gs('location_container')}>
                <div style={gs('form_small_text')}>{gc('location')}</div>
                <input
                  placeholder={gc('location_placeholder')}
                  type="text"
                  autoComplete="new-password"
                  onChange={this.onLocationTextUpdate}
                  value={this.props.globalData.location}
                  className={'removeFocusOutline'}
                  style={{
                    ...gs('input_form'),
                    border: this.state.location_border_validated
                      ? this.state.location_border
                      : borders.RED_BORDER
                  }}
                  onFocus={() => {
                    this.setState({
                      location_border: 'solid 1px rgba(0, 0, 0, 0.5)'
                    });
                  }}
                  onBlur={() => {
                    this.setState({
                      location_border: 'solid 1px rgba(0, 0, 0, 0.08)'
                    });
                  }}
                />
                <ClickAwayListener
                    onClickAway={this.handleClickAway}
                >
                  <div>
                {this.state.showDropdown && (
                  <DropdownMenuLocation
                    top={'73px'}
                    options={this.state.dropDownOptions}
                    style={{}}
                    change={this.onClickDropdown}
                  />
                )}
                  </div>
                </ClickAwayListener>
              </div>
              <div
                      style={{
                        ...gs('form_small_text'),
                        color: 'red',
                        lineHeight: '1.1',
                        height: '25px'
                      }}
                  >
                    {this.state.location_error}
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginBottom: '10px'
                }}
              >
                <SelectionCard
                  width={selectionCardWidth}
                  height={selectionCardHeight}
                  viewMode={this.props.viewMode}
                  selected={
                    this.props.globalData.type_of_property == propertyType.HOTEL
                  }
                  info_icon={gi('info_icon')}
                  type_icon={gi('hotel_icon')}
                  tick={gi('green_tick')}
                  type_text={guc('Hotel')}
                  type_style_tag={'hotel_icon'}
                  onClick={() => {
                    this.props.globalActions.updatePropertyType(
                      propertyType.HOTEL
                    );
                  }}
                />

                <SelectionCard
                  width={selectionCardWidth}
                  height={selectionCardHeight}
                  position={selectionCardPosition}
                  viewMode={this.props.viewMode}
                  selected={
                    this.props.globalData.type_of_property == propertyType.HOME
                  }
                  info_icon={gi('info_icon')}
                  type_icon={gi('house_icon')}
                  tick={gi('green_tick')}
                  type_text={guc('Home')}
                  type_style_tag={'house_icon'}
                  onClick={() => {
                    this.props.globalActions.updatePropertyType(
                      propertyType.HOME
                    );
                  }}
                />
              </div>

              {this.props.globalData.type_of_property === propertyType.HOTEL &&
                earningPotentialEnabled() && (
                  <Revenue
                    validateOneField={this.validateOneField}
                    amount={this.props.amount}
                    viewMode={this.props.viewMode}
                    eventCategory={EVENT_CATEGORIES.PARTNER_PAGE_LANDING_FORM}
                    eventAction={EVENT_ACTIONS.STEP_1_ROOM_COUNT_ENTERED}
                  />
                )}
              </div>
              <div
                style={{
                  ...gs('privacy_policy_style'),
                  position: 'absolute',
                  left: '20px',
                  color:isEmptyString(gc('privacy_color'))?gs('privacy_policy_style')['color']:gc('privacy_color')
                }}
              >
                <span style={{ fontSize: '12px' }}>
                  {gc('by_sharing_your')}{' '}
                  <a
                    style={{
                      textDecoration: 'underline'
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.oyoos.com/privacy-policy"
                    onClick={() => {
                      Event(
                        'Partner Page landing form',
                        'Privacy policy viewed',
                        '',
                        ''
                      );
                    }}
                  >
                    { gc('privacy_policy_2')}
                  </a>
                </span>
              </div>
            </div>
            <NavLink
              exact
              to={
                this.props.globalData.locale
                  ? '/' + this.props.globalData.locale + '/form'
                  : '/form'
              }
              style={{
                textDecoration: 'none',
                color: '#ffffff',
                position: 'absolute',
                bottom: this.props.globalData.locale === 'us' ? '25px' : '15px',
                width: '92%',
                margin: '0px 15px'
              }}
            >
              <button
                className="hoverColor"
                style={gs('join_us_btn')}
                onClick={this.onClickJoinUs}
              >
                <span>
                  {this.props.globalData.universal_translations.join_us}
                </span>
              </button>
            </NavLink>
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    globalActions: bindActionCreators(GlobalActions, dispatch)
  };
};

const mapStateToProps = state => {
  return {
    globalData: state.globalReducer
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(BecomeAnOyoForm3);
